import { put, takeEvery, all, call } from 'redux-saga/effects'
import { API } from '@Root/API'
import * as types from './studyLocation.types'
import { actions } from './studyLocation.actions'
import { saveDataOptionsToLocalStorage } from '@Root/helpers'
import { snackbarActions } from '@Root/store'

function* get({ payload }) {
  yield put(actions.toggleLoading(true))
  const { data, history } = payload
  const { studyProgrammeId, studentCourseSessionId, contactId, studyLocationId } = data
  try {
    const response = yield call(API.studies.studentCourseSession.studyLocation.get, studentCourseSessionId, studyLocationId)
    yield put(actions.set(response.data.data))
    yield put(actions.setPermissions(response.data.permissions))
  } catch (error) {
    history.push(`/home/studies/programmes/study/${contactId}/${studyProgrammeId}/study_location`)
    console.log(error)
  }
  yield put(actions.toggleLoading(false))
}

function* create({ payload }) {
  yield put(actions.toggleLoading(true))
  yield put(actions.setErrors({}))
  const { data, history, studyProgrammeId, contactId, studentCourseSessionId } = payload
  try {
    const response = yield call(API.studies.studentCourseSession.studyLocation.create, studentCourseSessionId, data)
    yield put(actions.set(response.data.data))
    history.push(`/home/studies/programmes/study/${contactId}/${studyProgrammeId}/study_location/${response.data.data.id}`)
    yield put(snackbarActions.setSuccessNotification({ text: 'The Study Location has been created successfully!' }))
  } catch (error) {
    const errors = error.response.data.messages
    if (errors['studyProgrammeId']) {
      history.push('/home/studies/programmes/study')
    } else {
      yield put(actions.set(data))
      yield put(actions.setErrors(errors))
    }
  }
  yield put(actions.toggleLoading(false))
}

function* edit({ payload }) {
  yield put(actions.toggleLoading(true))
  yield put(actions.setErrors({}))
  const { studyLocationId, studentCourseSessionId, data } = payload
  try {
    const response = yield call(API.studies.studentCourseSession.studyLocation.edit, studentCourseSessionId, studyLocationId, data)
    yield put(actions.set(response.data.data))

    yield put(actions.toggleSuccess(true))
    yield put(snackbarActions.setSuccessNotification({ text: 'The Study Location has been saved successfully!' }))
  } catch (error) {
    const errors = error.response.data.messages
    yield put(actions.set(data))
    yield put(actions.setErrors(errors))
  }
  yield put(actions.toggleSuccess(false))
  yield put(actions.toggleLoading(false))
}

function* remove({ payload }) {
  yield put(actions.toggleLoading(true))
  const { data, history } = payload
  const { contactId, studyProgrammeId, studentCourseSessionId, studyLocationId } = data
  try {
    yield call(API.studies.studentCourseSession.studyLocation.remove, studentCourseSessionId, studyLocationId)
    history.push(`/home/studies/programmes/study/${contactId}/${studyProgrammeId}/study_location`)
    yield put(snackbarActions.setSuccessNotification({ text: 'The Study Location has been deleted successfully!' }))
  } catch (error) {
    console.log(error)
  }
  yield put(actions.toggleLoading(false))
}

function* getOptions() {
  try {
    const { data } = yield call(API.studies.studentCourseSession.studyLocation.options.getStatic)
    const generateObject = arr => arr.map(obj => ({ value: obj.id, label: `${obj.code} - ${obj.label}` }))
    const formattedData = {
      distance_learning: generateObject(data.distance_learning),
      primarily_outside_uk: generateObject(data.primarily_outside_uk),
    }
    yield put(actions.setOptions(formattedData))
    saveDataOptionsToLocalStorage('studyLocation', formattedData)
  } catch (error) {
    console.log(error)
  }
}

export function* rootSaga() {
  yield all([
    takeEvery(types.GET_STUDY_LOCATION, get),
    takeEvery(types.CREATE_STUDY_LOCATION, create),
    takeEvery(types.EDIT_STUDY_LOCATION, edit),
    takeEvery(types.DELETE_STUDY_LOCATION, remove),
    takeEvery(types.GET_OPTIONS, getOptions),
  ])
}
